import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_additional_safety_measur'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_additional_safety_measur',
  name: 'Does the facility have any of the following additional safety measures in place related to emergency exits?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'EMERGENCY_EXITS_ARE_ILLUMINATED_AND_VISIBLE_WHEN_IT_IS_DARK_OR_',
      text: 'Emergency exits are illuminated and visible when it is dark or there is smoke',
      externalIds: [
        {
          id: 'hs-22-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_EXIT_DOORS_OPEN_OUTWARDS_OR_ARE_SECURELY_KEPT_OPEN_DU',
      text: 'Emergency exit doors open outwards or are securely kept open during working hours',
      externalIds: [
        {
          id: 'hs-22-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DOORS_THAT_ARE_NOT_EXITS_ARE_CLEARLY_MARKED_AS_NOT_AN_EXIT_',
      text: 'Doors that are not exits are clearly marked as "Not an Exit"',
      externalIds: [
        {
          id: 'hs-22-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_EXIT_LIGHTING_HAS_A_BACK_UP_BATTERY_PROVIDING_CONTINU',
      text: 'Emergency exit lighting has a back-up battery providing continuous lighting within a timeframe',
      externalIds: [
        {
          id: 'hs-22-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-22-10x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'EMERGENCY_EXITS_ARE_ILLUMINATED_AND_VISIBLE_WHEN_IT_IS_DARK_OR_',
                'EMERGENCY_EXIT_DOORS_OPEN_OUTWARDS_OR_ARE_SECURELY_KEPT_OPEN_DU',
                'DOORS_THAT_ARE_NOT_EXITS_ARE_CLEARLY_MARKED_AS_NOT_AN_EXIT_',
                'EMERGENCY_EXIT_LIGHTING_HAS_A_BACK_UP_BATTERY_PROVIDING_CONTINU',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14850,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
